import { cva } from 'class-variance-authority';
import type { Size } from '../types';

const sizeVariants = {
  large: 'text-size-body-2xl ml-2',
  medium: 'text-size-body-lg ml-[13px]',
  small: 'text-size-body-sm ml-1.5',
  byBreakpoint: 'text-size-body-lg lg:text-size-body-2xl ml-[13px] lg:ml-2',
} satisfies Record<Size, string>;

export const flag = cva(
  'text-color-text-light absolute font-bold [-webkit-text-stroke:1px_rgba(0,0,0,1)]',
  {
    variants: {
      size: sizeVariants,
    },
    defaultVariants: { size: 'medium' },
  },
);
